import { cva } from 'class-variance-authority'

export type HalfHalfBlockLayoutVariant = 'Left Image' | 'Right Image' | 'Image Top' | 'Text Top'

export const sectionVariants = cva('w-full px-4 md:px-12 lg:px-28 xl:px-30', {
  variants: {
    backgroundColor: {
      White: 'bg-white',
      Grey: 'bg-grey-100',
      None: '',
    },
    contained: {
      true: '',
      false: '',
    },
    topSpacing: {
      true: 'pt-8 md:pt-16 lg:pt-24',
      false: '',
    },
    bottomSpacing: {
      true: 'pb-8 md:pb-16 lg:pb-24',
      false: '',
    },
  },
  compoundVariants: [
    {
      contained: true,
      backgroundColor: 'None',
      class: 'bg-grey-100',
    },
  ],
  defaultVariants: {
    backgroundColor: 'White',
    contained: false,
    topSpacing: true,
    bottomSpacing: true,
  },
})

export const containerVariants = cva('flex justify-between gap-0 md:gap-12 lg:gap-24 content:mx-auto content:max-w-content', {
  variants: {
    layout: {
      'Left Image': 'md:flex-row',
      'Right Image': 'md:flex-row-reverse',
      'Image Top': 'flex-col',
      'Text Top': 'flex-col-reverse',
    },
    mobileLayout: {
      'Left Image': 'md:flex-row',
      'Right Image': 'md:flex-row-reverse',
      'Image Top': 'flex-col',
      'Text Top': 'flex-col-reverse',
    },
    contained: {
      true: 'rounded-xl p-6 shadow-sm md:p-12',
      false: '',
    },
    blockBackgroundColor: {
      White: 'bg-white',
      Grey: 'bg-grey-100',
      None: '',
    },
  },
  defaultVariants: {
    layout: 'Left Image',
    mobileLayout: 'Image Top',
    contained: false,
    blockBackgroundColor: 'None',
  },
})
